import React from "react";

import { Link } from "react-router-dom";

import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import { LinkButton } from "Theme/Button";

export type Crumb = {
  title: string;
  link: string;
};

type BreadrumbsProps = {
  crumbs: Crumb[];
};

const Breadcrumbs = ({ crumbs, ...rest }: BreadrumbsProps) => (
  <Div p={4} {...rest}>
    <nav aria-label="breadcrumb">
      <Div className="flex justify-start">
        {crumbs.map((crumb, index) => (
          <Div key={index} className="flex items-center">
            {index !== 0 && <Icon icon="chevron-right" mx={3} />}
            {index === crumbs.length - 1 ? (
              <span>{crumb.title}</span>
            ) : (
              <LinkButton component={Link} to={crumb.link} color="link" p={0}>
                {crumb.title}
              </LinkButton>
            )}
          </Div>
        ))}
      </Div>
    </nav>
  </Div>
);

export default Breadcrumbs;
